"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("../../context/store");
const react_1 = require("react");
const renderCols = (calendarDays, translations) => {
    return calendarDays.map((item, index) => {
        if (index % 7 === 0 && index < 7 * 5) {
            const weekNum = item.weekNumber;
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__WeekNumbersCol__container' }, { children: (0, jsx_runtime_1.jsxs)("p", Object.assign({ className: 'Kalend__WeekNumbersCol__text' }, { children: [translations['weekShort'], weekNum] })) }), item.toString()));
        }
        else if (index % 7 === 0 && index >= 7 * 5) {
            const weekNum = item.weekNumber;
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__WeekNumbersCol__container--no-border' }, { children: (0, jsx_runtime_1.jsxs)("p", Object.assign({ className: 'Kalend__WeekNumbersCol__text' }, { children: [translations['weekShort'], weekNum] })) }), item.toString()));
        }
    });
};
const WeekNumbersCol = () => {
    const [store] = (0, react_1.useContext)(store_1.Context);
    const cols = renderCols(store.calendarDays, store.translations);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__WeekNumbersCol__wrapper' }, { children: cols }));
};
exports.default = WeekNumbersCol;
